// Browsers cannot refill file inputs from HTML, so keep their DOM nodes on validation errors.
document.addEventListener('submit', async (event) => {
  const form = event.target
  if (!form.matches('form[data-preserve-uploads]')) return

  event.preventDefault()
  // Rails UJS must not submit or disable this form independently.
  event.stopImmediatePropagation()
  if (form.dataset.submitting) return

  const body = new FormData(form)
  const buttons = Array.from(form.querySelectorAll('[type=submit]'))
  const error = form.querySelector('[data-upload-error]')
  form.dataset.submitting = 'true'
  buttons.forEach(button => { button.disabled = true })
  error.hidden = true

  try {
    const response = await fetch(form.action, {
      method: form.method,
      body,
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })

    if (response.ok) {
      const result = await response.json()
      const location = new URL(result.location, window.location.href)
      if (!result.location || location.origin !== window.location.origin) throw new Error('Invalid redirect')
      window.location.assign(location.href)
      return
    }

    if (response.status !== 422) throw new Error('Save failed')
    const document = new DOMParser().parseFromString(await response.text(), 'text/html')
    const replacement = document.querySelector('form[data-preserve-uploads]')
    if (!replacement) throw new Error('Missing form')

    form.querySelectorAll('input[type=file]').forEach(input => {
      const nextInput = replacement.querySelector(`input[type=file][name="${input.name}"]`)
      if (!nextInput) return
      input.className = nextInput.className
      for (const attribute of ['aria-invalid', 'aria-describedby']) {
        if (nextInput.hasAttribute(attribute)) input.setAttribute(attribute, nextInput.getAttribute(attribute))
        else input.removeAttribute(attribute)
      }
      nextInput.replaceWith(input)
    })
    form.replaceWith(replacement)
    replacement.querySelectorAll('input[type=file]').forEach(input => {
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
    replacement.querySelector('.is-invalid')?.focus()
  } catch {
    error.hidden = false
  } finally {
    delete form.dataset.submitting
    buttons.forEach(button => { button.disabled = false })
  }
}, true)
